import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { Test } from './Test';

export default class TestResource extends FBaseService {
  public async getAll(): Promise<Test[]> {
    const url = '/api/test/';
    const response: AxiosResponse = await this.apiClient.get(url);
    return response.data.data;
  }

  public async get(name: string): Promise<Test | null> {
    const url = `/api/test/${encodeURIComponent(name)}`;
    try {
      const response: AxiosResponse = await this.apiClient.get(url);
      return response.data.data;
    } catch (error) {
      // Will 404 if test does not exist.  Just return null.
      if (error.response.status !== 404) {
        throw error;
      } else {
        return null;
      }
    }
  }

  public async save(test: Test): Promise<Test> {
    const url = '/api/test/';

    const response: AxiosResponse = await this.apiClient.put(url, test);
    return response.data.data;
  }

  public async delete(name: string): Promise<Test> {
    const url = `/api/test/${name}`;
    const response: AxiosResponse = await this.apiClient.delete(url);
    return response.data.data;
  }

  public async getTestResult(name: string): Promise<string> {
    const url = `/api/test/${name}/result`;
    const response: AxiosResponse = await this.apiClient.get(url);
    return response.data.data;
  }
}
